import React from "react";
import RouterApp from "./routerApp";

import CssBaseline from "@mui/material/CssBaseline";
import { ToastContainer } from "react-toastify";
import { theme } from "../theme";
import CookieBanner from "./common/CookieBanner";
import Footer from "./main/Footer/Footer";

import { ThemeProvider } from "@mui/material/styles";
import TopBar from "./main/Header/TopBar";

import "react-toastify/dist/ReactToastify.css";
import Box from "@mui/material/Box";
import Copyright from "./common/Copyright";

const App = () => {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
				<TopBar />
				<ToastContainer autoClose={3000} hideProgressBar pauseOnHover={true} />
				<Box component="main" sx={{ flexGrow: 1 }}>
					<RouterApp />
				</Box>
				<Footer />
				<Copyright />
				<CookieBanner />
			</Box>
		</ThemeProvider>
	);
};

export default App;
